import { keyframes } from 'styled-components'

const spinY = keyframes`
    0%   { transform: rotateY(0); }
    100% { transform: rotateY(180deg); }
`

export { spinY } /* eslint-disable-line import/prefer-default-export */
